import { url, token } from '@/api/api.js'

var myHeaders = new Headers();
myHeaders.append("Cookie", "mailchimp_landing_site=https%3A%2F%2Fccm.sitepreview.app%2Fwc-auth%2Fv1%2Fauthorize%3Fck_4300411a88c76eace32567945afbe0ea92aeb372%3Dcs_50a10ddbd8d0ca76b6435e53273bf9408645d28d");
myHeaders.append('Content-Type', 'application/json');

var requestOptions = {
  credentials: 'include',
  headers: myHeaders,
  redirect: 'follow'
};

export default {
  state: {
    userDetails: {},
    loader: false,
  },
  mutations: {
    setUserDetails ( state, payload) {
            
        state.userDetails = payload || {};

    },
    viewLoader ( state, payload) {
      state.loader = payload || false;
     
      if( payload == true ) {
         document.body.classList.add('hidden');
      } else {
         document.body.classList.remove('hidden');
      }
    },
 
  },
  actions: {
    async getUserDetails ( {commit} ) { 

      commit( 'viewLoader', true );
      requestOptions.method = 'GET';
      
      try {
        const Data = await fetch(url + "/wp-json/ccm-settings/v1/user-details", requestOptions);        
        
        if ( Data.status == 200 ) {
          const data = await Data.text();
          const dataParse = await JSON.parse(data);
          commit('setUserDetails', dataParse);
          commit('viewLoader', false);
        } else {
          console.log('error', 'error.message');
        }

      } catch ( error ) {
        commit( 'viewLoader', false );
        //   commit( 'setUserLogin', error.message.replace('username', 'phone') );
        console.log('error', error.message);
        throw error;
          
      }
    },
    async saveUserDetails({commit}, data) {      
     
      commit( 'viewLoader', true );
      myHeaders.append("Authorization", "Bearer " + token);      

      requestOptions.method = 'POST';
      requestOptions.body = JSON.stringify(data);

      try {

        const Data = await fetch(url + "/wp-json/ccm-settings/v1/user-details", requestOptions);
        if ( Data.status == 200 ) {
          const data = await Data.text();

          if ( data ) {
            const dataParse = await JSON.parse(data);
            console.log(dataParse);
          }
          
          commit( 'viewLoader', false );
          commit('setAlertData', { title: 'Success', text: 'The data was saved! There will be a present waiting for you on your birthday.', type: 'success', visible: true } );       
        } else {
          commit('setAlertData', { title: 'Error', text: 'The data was not saved. Please try again later', type: 'error', visible: true });
        }
              
      } catch ( error ) {
        commit( 'viewLoader', false );
        commit( 'setAlertData', {title: 'Error', text: error.message.replace('username', 'phone'), type: 'error', visible: true } );
        console.log('error', error.message);
        throw error;          
      }
    },
  },
  getters: {
    userDetails ( state ) {
      return state.userDetails;
    },
    loader ( state ) {
      return state.loader;
    },
  }
}
